export enum DeliveryDateType {
    FixedDate = 'FIXED_DATE',
    Deadline = 'DEADLINE',
    DesiredDate = 'DESIRED_DATE',
}

const translationObject: { [Key in DeliveryDateType]: string } = {
    [DeliveryDateType.FixedDate]: 'app.common.deliveryDateType.fixedDate',
    [DeliveryDateType.Deadline]: 'app.common.deliveryDateType.deadline',
    [DeliveryDateType.DesiredDate]: 'app.common.deliveryDateType.desiredDate',
};

/**
 * The order the choice is offered in, so a mask does not spell it out itself.
 * Both places that offered it had the two values written out, which is how a
 * third one gets added in one mask and forgotten in the other.
 *
 * The wish date comes last: it was asked for as a third option beside the two
 * that were there, and putting it first would move what people aim at today.
 */
export const deliveryDateTypeOrder: DeliveryDateType[] = [
    DeliveryDateType.Deadline,
    DeliveryDateType.FixedDate,
    DeliveryDateType.DesiredDate,
];

export const getDeliveryDateTypeTranslationId = (deliveryDateType?: DeliveryDateType): string => {
    return translationObject[deliveryDateType ?? DeliveryDateType.FixedDate];
};

const shortTranslationObject: { [Key in DeliveryDateType]: string } = {
    [DeliveryDateType.FixedDate]: 'app.common.deliveryDateType.short.fixedDate',
    [DeliveryDateType.Deadline]: 'app.common.deliveryDateType.short.deadline',
    [DeliveryDateType.DesiredDate]: 'app.common.deliveryDateType.short.desiredDate',
};

/** The kind as one word before a date in a list column — "bis 12.10.", "fix 14.10." (#2267). */
export const getDeliveryDateTypeShortTranslationId = (deliveryDateType?: DeliveryDateType): string =>
    shortTranslationObject[deliveryDateType ?? DeliveryDateType.FixedDate];

const toggleTranslationObject: { [Key in DeliveryDateType]: string } = {
    [DeliveryDateType.FixedDate]: 'app.common.deliveryDateType.toggle.fixedDate',
    [DeliveryDateType.Deadline]: 'app.common.deliveryDateType.toggle.deadline',
    [DeliveryDateType.DesiredDate]: 'app.common.deliveryDateType.toggle.desiredDate',
};

/** The kind on the switch beside a date in a document head — "Spätestens", "Fix", "Wunsch" (#2251). */
export const getDeliveryDateTypeToggleTranslationId = (deliveryDateType?: DeliveryDateType): string =>
    toggleTranslationObject[deliveryDateType ?? DeliveryDateType.FixedDate];
